import i18next from "i18next"

import common_es from "./es/common.json"
import common_en from "./en/common.json"
import common_pt from "./pt/common.json"
import editor_en from "./en/editor.json"
import editor_es from "./es/editor.json"
import editor_pt from "./pt/editor.json"

const storedLanguage = (() => {
  try {
    const value = localStorage.getItem("i18nextLng") || ""
    const short = value.slice(0, 2).toLowerCase()
    return ["pt", "en", "es"].includes(short) ? short : ""
  } catch {
    return ""
  }
})()

i18next.init({
  interpolation: { escapeValue: false },
  lng: storedLanguage || "en",
  fallbackLng: "en",
  supportedLngs: ["pt", "en", "es"],
  resources: {
    en: {
      common: common_en,
      editor: editor_en,
    },
    es: {
      common: common_es,
      editor: editor_es,
    },
    pt: {
      common: common_pt,
      editor: editor_pt,
    },
  },
})

i18next.on("languageChanged", (language) => {
  try {
    localStorage.setItem("i18nextLng", language)
    document.documentElement.lang = language
  } catch {
    // storage may be unavailable
  }
})

try {
  document.documentElement.lang = i18next.language
} catch {
  // ignore
}

export default i18next
